var React = require('react');

function CalendarDescription (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11 3V1H0V3H11ZM12 5V7H0V5H12ZM7 9V11H0V9H7Z","fill":"currentColor"}));
}

CalendarDescription.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = CalendarDescription;

CalendarDescription.default = CalendarDescription;
